var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHipster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.209 469.209",
    style: {
      enableBackground: "new 0 0 469.209 469.209"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 42.605,
    y: 370.737,
    style: {
      fill: "#F9BDA0"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#750A4C"
    },
    d: "M139.677,124.249l75.064-15.368l4.536,104.008l-28.04,32.56l4.232,36.024 c0,0-42.776,58.256-53.44,37.592c-10.656-20.664-5.888-184.248-7.232-186.92C133.469,129.482,139.677,124.249,139.677,124.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#440131"
    },
    d: "M134.797,132.154c-1.328-2.672,4.872-7.896,4.872-7.896l75.064-15.368l4.536,104.008l-28.04,32.56 l4.232,36.024"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#750A4C"
    },
    d: "M329.549,124.249l-75.064-15.368l-4.536,104.016l28.04,32.56l-3.952,63.616c0,0,43.344-42.336,54-63 c10.664-20.664,5.048-111.248,6.376-113.92C335.757,129.482,329.549,124.249,329.549,124.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#440131"
    },
    d: "M334.413,132.154c1.344-2.672-4.856-7.896-4.856-7.896l-75.064-15.368l-4.544,104.008l28.04,32.56 l-4.232,36.024"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.605,
    y: 186.738,
    style: {
      fill: "#F9BDA0"
    },
    width: 96,
    height: 200
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA78C"
    },
    points: "282.605,280.145 282.605,186.738 187.581,186.738 235.813,321.273 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M309.565,102.122c0,72.24-36.624,137.616-74.944,137.616s-74.96-65.376-74.96-137.616 s36.64-84.288,74.96-84.288S309.565,29.882,309.565,102.122z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M234.621,17.834c38.32,0,74.944,12.048,74.944,84.288s-36.624,137.616-74.944,137.616"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "190.333,286.313 34.141,334.393 42.141,469.209 231.125,421.353  "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FCCCB9"
    },
    points: "34.141,334.393 42.141,469.209 231.125,421.353 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "278.893,286.313 435.069,334.393 427.069,469.209 238.069,421.353 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#EAA78C"
    },
    points: "435.069,334.393 427.069,469.209 238.069,421.353 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B1964"
    },
    d: "M245.037,13.074c0,0-4.136,105.92,89.92,117.568c0,0,3.064-70.688-23-101.504 c-26.08-30.8-66.44-27-66.44-27L245.037,13.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C12B81"
    },
    d: "M269.989,3.962c0,0,143.048,73.112-135.672,132.048c0,0-11.784-75.976,18.984-108.528 c30.76-32.56,85.92-27.144,85.92-27.144L269.989,3.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF226C"
    },
    d: "M269.989,3.962c0,0,143.048,73.112-135.672,132.048"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.605,
    y: 370.737,
    style: {
      fill: "#EA5807"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.605,
    y: 386.737,
    style: {
      fill: "#B21302"
    },
    width: 384,
    height: 80
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD3A4"
    },
    points: "228.621,466.737 180.413,286.785 33.597,332.345 37.829,466.737 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "228.621,466.737 180.413,286.785 33.597,332.345 53.829,466.737 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "228.621,466.737 180.413,286.785 33.597,332.345 85.829,466.737 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D35E0D"
    },
    points: "240.589,466.737 288.797,286.785 435.613,332.345 431.381,466.737 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63C6BD"
    },
    d: "M224.533,138.361c0,15.68-13.408,28.376-29.92,28.376c-16.528,0-29.936-12.696-29.936-28.376 s13.408-21.288,29.936-21.288C211.125,117.074,224.533,122.682,224.533,138.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M194.613,170.738c-18.712,0-33.936-14.52-33.936-32.376c0-16.072,12.368-25.288,33.936-25.288 c21.56,0,33.92,9.216,33.92,25.288C228.533,156.217,213.317,170.738,194.613,170.738z M194.613,121.074 c-17.208,0-25.936,5.816-25.936,17.288c0,13.44,11.64,24.376,25.936,24.376s25.92-10.936,25.92-24.376 C220.533,126.889,211.813,121.074,194.613,121.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M162.605,138.738h-8c-2.208,0-4-1.792-4-4s1.792-4,4-4h8c2.208,0,4,1.792,4,4 S164.813,138.738,162.605,138.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63C6BD"
    },
    d: "M244.677,138.361c0,15.68,13.408,28.376,29.92,28.376c16.528,0,29.936-12.696,29.936-28.376 s-13.408-21.288-29.936-21.288C258.085,117.074,244.677,122.682,244.677,138.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M274.597,170.738c-18.704,0-33.92-14.52-33.92-32.376c0-16.072,12.36-25.288,33.92-25.288 c21.568,0,33.936,9.216,33.936,25.288C308.533,156.217,293.309,170.738,274.597,170.738z M274.597,121.074 c-17.2,0-25.92,5.816-25.92,17.288c0,13.44,11.632,24.376,25.92,24.376c14.304,0,25.936-10.936,25.936-24.376 C300.533,126.889,291.805,121.074,274.597,121.074z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M314.605,138.738h-8c-2.208,0-4-1.792-4-4s1.792-4,4-4h8c2.208,0,4,1.792,4,4 S316.813,138.738,314.605,138.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E06612"
    },
    d: "M244.693,143.745c-2.208,0-4-1.792-4-4c0-3.352-2.736-6.088-6.096-6.088 c-3.352,0-6.08,2.728-6.08,6.088c0,2.208-1.792,4-4,4s-4-1.792-4-4c0-7.768,6.32-14.088,14.08-14.088 c7.768,0,14.096,6.32,14.096,14.088C248.693,141.954,246.901,143.745,244.693,143.745z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D11900"
    },
    points: "168.437,281.073 187.069,260.409 234.605,304.409 234.605,394.737 208.765,394.737  191.957,336.905 144.229,298.153 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B21302"
    },
    points: "300.773,281.073 282.157,260.409 234.605,304.409 234.605,394.737 260.445,394.737  277.245,336.905 324.981,298.153 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 234.605,
    cy: 315.777,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 234.605,
    cy: 343.409,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 234.605,
    cy: 371.057,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 234.605,
    cy: 398.737,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB743"
    },
    cx: 234.605,
    cy: 426.401,
    r: 5.336
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "54.725,339.465 50.765,338.826 48.581,341.105 54.925,350.353 60.901,340.857  58.637,338.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "86.429,338.826 82.477,338.177 80.301,340.457 86.645,349.705 92.629,340.201  90.357,338.009  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "118.141,338.177 114.197,337.529 112.005,339.809 118.381,349.049 124.341,339.553  122.077,337.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "149.861,337.521 145.917,336.882 143.725,339.153 150.101,348.401 156.061,338.905  153.773,336.721  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "181.573,336.873 177.621,336.233 175.445,338.505 181.789,347.761 187.773,338.257  185.493,336.065  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "58.109,367.009 54.165,366.378 51.981,368.649 58.333,377.905 64.309,368.401  62.029,366.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "89.821,366.369 85.877,365.729 83.709,368.001 90.053,377.249 96.005,367.753  93.741,365.569  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "121.541,365.721 117.581,365.081 115.405,367.353 121.765,376.602 127.725,367.097  125.437,364.921  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "153.261,365.073 149.301,364.425 147.117,366.705 153.469,375.953 159.445,366.449  157.181,364.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "184.965,364.425 181.021,363.777 178.837,366.057 185.189,375.305 191.165,365.801  188.893,363.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "61.493,394.569 57.549,393.929 55.357,396.209 61.725,405.449 67.693,395.953  65.429,393.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "93.205,393.913 89.261,393.273 87.093,395.561 93.437,404.801 99.421,395.297  97.133,393.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "124.941,393.266 120.997,392.625 118.797,394.905 125.149,404.153 131.125,394.649  128.853,392.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "156.653,392.617 152.701,391.977 150.501,394.257 156.885,403.505 162.837,394.001  160.565,391.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "188.365,391.969 184.413,391.329 182.237,393.602 188.589,402.857 194.557,393.353  192.293,391.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "64.893,422.113 60.941,421.481 58.765,423.745 65.117,433.001 71.093,423.505  68.813,421.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "96.605,421.465 92.661,420.833 90.477,423.105 96.821,432.345 102.797,422.857  100.517,420.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "128.325,420.809 124.381,420.177 122.197,422.457 128.557,431.697 134.525,422.209  132.237,420.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "160.061,420.169 156.093,419.529 153.917,421.809 160.269,431.049 166.221,421.553  163.957,419.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "191.765,419.521 187.805,418.882 185.621,421.161 191.981,430.401 197.949,420.905  195.685,418.721  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "68.293,449.658 64.341,449.025 62.141,451.289 68.509,460.553 74.477,451.049  72.213,448.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "99.989,449.009 96.053,448.378 93.861,450.649 100.221,459.905 106.197,450.401  103.933,448.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "131.725,448.369 127.773,447.729 125.581,450.001 131.941,459.249 137.917,449.753  135.645,447.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "163.429,447.721 159.485,447.081 157.293,449.353 163.669,458.593 169.629,449.105  167.365,446.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9240"
    },
    points: "195.149,447.065 191.189,446.425 189.029,448.705 195.381,457.945 201.357,448.449  199.069,446.266  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "414.493,339.465 418.437,338.826 420.629,341.105 414.277,350.353 408.309,340.857  410.573,338.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "382.781,338.826 386.725,338.177 388.909,340.457 382.557,349.705 376.581,340.201  378.853,338.009  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "351.069,338.177 355.013,337.529 357.189,339.809 350.837,349.049 344.869,339.553  347.133,337.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "319.333,337.521 323.293,336.882 325.485,339.153 319.109,348.401 313.149,338.905  315.429,336.721  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "287.637,336.873 291.589,336.233 293.765,338.505 287.421,347.761 281.437,338.257  283.725,336.065  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "411.101,367.009 415.053,366.378 417.229,368.649 410.877,377.905 404.901,368.401  407.173,366.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "379.397,366.369 383.333,365.729 385.509,368.001 379.165,377.249 373.189,367.753  375.453,365.569  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "347.669,365.721 351.621,365.081 353.805,367.353 347.445,376.602 341.469,367.097  343.765,364.921  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "315.949,365.073 319.901,364.425 322.093,366.705 315.725,375.953 309.765,366.449  312.029,364.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "284.237,364.425 288.189,363.777 290.381,366.057 284.021,375.305 278.053,365.801  280.317,363.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "407.725,394.569 411.661,393.929 413.853,396.209 407.485,405.449 401.517,395.953  403.781,393.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "375.989,393.913 379.949,393.273 382.109,395.561 375.765,404.801 369.789,395.297  372.077,393.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "344.269,393.266 348.213,392.625 350.413,394.905 344.061,404.153 338.085,394.649  340.357,392.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "312.557,392.617 316.509,391.977 318.701,394.257 312.325,403.505 306.381,394.001  308.645,391.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "280.845,391.969 284.789,391.329 286.973,393.602 280.621,402.857 274.645,393.353  276.909,391.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "404.317,422.113 408.261,421.481 410.437,423.745 404.093,433.001 398.109,423.505  400.397,421.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "372.605,421.465 376.533,420.833 378.733,423.105 372.397,432.345 366.397,422.857  368.677,420.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "340.885,420.809 344.837,420.177 347.013,422.457 340.653,431.697 334.677,422.209  336.965,420.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "309.149,420.169 313.117,419.529 315.293,421.809 308.941,431.049 302.981,421.553  305.245,419.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "277.437,419.521 281.405,418.882 283.589,421.161 277.229,430.401 271.261,420.905  273.525,418.721  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "400.909,449.658 404.869,449.025 407.069,451.289 400.701,460.553 394.725,451.049  396.989,448.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "369.205,449.009 373.157,448.378 375.333,450.649 368.989,459.905 363.013,450.401  365.277,448.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "337.469,448.369 341.437,447.729 343.621,450.001 337.269,459.249 331.293,449.753  333.565,447.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "305.773,447.721 309.725,447.081 311.917,449.353 305.541,458.593 299.581,449.105  301.845,446.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF7507"
    },
    points: "274.061,447.065 278.005,446.425 280.181,448.705 273.829,457.945 267.845,448.449  270.125,446.266  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF226C"
    },
    d: "M135.709,216.081c0,0-8,111.656,30.672,131.992c20.2,10.632,34.328,35.336-6.32,72.096 c0,0,62.792-39.728,32.976-77.096c-23.656-29.656-15-63-15-63s0,22.248,30,29c0,0-26.496-10-21.504-36.496 c2.512-13.304-2.496-25.248-12-29.752s-14,5.752-14,5.752L135.709,216.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#750A4C"
    },
    d: "M192.005,389.945c9.4-13.728,14.08-30.528,1.032-46.872c-23.656-29.656-15-63-15-63s0,22.248,30,29 c0,0-26.496-10-21.504-36.496c2.512-13.304-2.496-25.248-12-29.752s-14,5.752-14,5.752l-24.832-32.496"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipster);
export default __webpack_public_path__ + "static/media/hipster.f4de5495fac55ba2da9abd0c66e76baa.svg";
export { ForwardRef as ReactComponent };